<template>
  <div>
    <header-tool-bar @toggleDrawer="drawer = !drawer"></header-tool-bar>
    <sidebar :drawer="drawer"/>
    <v-content class="page-content">
      <slot />
    </v-content>
    <loader></loader>
    <error-popup></error-popup>
  </div>
</template>

<script>
    import sidebar from '../components/common/sidebar'
    import headerToolBar from '../components/common/headerToolBar'
    import loader from '../components/common/loader'
    import errorPopup from "../components/common/errorPopup";
    export default {
        name: "Default",
        components: {
          errorPopup,
          sidebar,
          headerToolBar,
          loader
        },
        data () {
          return {
            drawer: true
          }
        }
    }
</script>

<style scoped>

</style>